import type { CalculationColumn } from '../../types/column-types'
import { uiColorColumn } from './ui-color'
import { calculatedMarginRatioColumn } from './calculated-margin-ratio'
import { currencyRateColumn } from './currency-rate'
import { commentColumn } from './comment'
import { copiesColumn } from './copies'
import { materialTypeNameColumn } from './material-type-name'
import { additionalJobsColumn } from './additional-jobs'
import { stampIdColumn } from './stamp-id'
import { stampWidthColumn } from './stamp-width'
import { stampLengthColumn } from './stamp-length'
import { stampFloodsColumn } from './stamp-floods'
import { stampRollerRollerColumn } from './stamp-roller-roller'
import { machineNameColumn } from './machine-name'
import { additionalMachinesColumn } from './additional-machines'
import { lacquersDmsColumn } from './lacquers-dms'
import { whitewashColumn } from './whitewash'
import { cmykColumn } from './cmyk'
import { pantonesColumn } from './pantones'
import { lacquersColumn } from './lacquers'
import { calculatedMaterialWidthColumn } from './calculated-material-width'
import { materialWidthColumn } from './material-width'
import { additionalMaterialsColumn } from './additional-materials'
import { calculatedMaterialLengthColumn } from './calculated-material-length'
import { numberOfFormsColumn } from './number-of-forms'
import { formSetColumn } from './form-set'
import { accumulationColumn } from './accumulation'
import { sellingPriceColumn } from './selling-price'
import { calculatedMoneyColumns } from './calculated-money'
import { calculatedConsumablesColumns } from './calculated-consumables'
import { calculatedTimeColumns } from './calculated-time'
import { calculatedLabelAreaColumn } from './calculated-label-area'
import { calculatedMaterialWeightColumn } from './calculated-material-weight'
import { paintCostOf1000DurstWGColumn } from './paint-cost-of-1000-durst-wg'
import { validationStatusColumn } from './validation-status'
import { actionsColumn } from './8'
import { numberOfVariantsForDigitColumn } from './number-of-variants-for-digit'
import { materialCostCorrectColumn } from './material-cost-correct'
import { correctMaterialCostColumn } from './correct-material-cost'
import { floodsInAccumulation } from './floods-in-accumulation'
import { createdShipmentPositionColumn } from './created-shipment-position'
import { withoutCuttingColumn } from './without-cutting'
import { idCalculatuionPositionColumn } from './id-calculation-position'
import { shipmentTypeColumn } from './shipment-type'

export const columns: CalculationColumn[] = [
    uiColorColumn,
    idCalculatuionPositionColumn,
    calculatedMarginRatioColumn,
    currencyRateColumn,
    commentColumn,
    materialTypeNameColumn,
    additionalJobsColumn,
    shipmentTypeColumn,
    withoutCuttingColumn,
    stampIdColumn,
    stampWidthColumn,
    stampLengthColumn,
    stampFloodsColumn,
    stampRollerRollerColumn,
    machineNameColumn,
    additionalMachinesColumn,
    lacquersDmsColumn,
    whitewashColumn,
    cmykColumn,
    pantonesColumn,
    lacquersColumn,
    calculatedMaterialWidthColumn,
    materialWidthColumn,
    additionalMaterialsColumn,
    calculatedMaterialLengthColumn,
    accumulationColumn,
    floodsInAccumulation,
    numberOfVariantsForDigitColumn,
    copiesColumn,
    sellingPriceColumn,
    ...calculatedMoneyColumns,
    ...calculatedConsumablesColumns,
    ...calculatedTimeColumns,
    calculatedLabelAreaColumn,
    calculatedMaterialWeightColumn,
    numberOfFormsColumn,
    formSetColumn,
    paintCostOf1000DurstWGColumn,
    // materialCostCorrectColumn,
    correctMaterialCostColumn,
    validationStatusColumn,
    createdShipmentPositionColumn,
    actionsColumn,
]
